module.exports = __webpack_public_path__ + "static/img/banner.f3ff563.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon/archives/banner.jpg
// module id = GO96
// module chunks = 55